export enum AppointmentNotificationType {
  Email = 1,
  SMS = 2,
  AutomatedPhoneCall = 3,
  ByStaff = 4,
  DoNotSend = 5,
}
